import { useSelector } from "react-redux";
import { AppState } from "@Store/index";
import { addCountryWiseContactInfo } from "@Components/FooterV2/constant";

const useCountryContactInfo = () => {
  const country = useSelector(
    ({ appData }: AppState) =>
      appData.country ||
      (typeof window !== "undefined" ? localStorage.getItem("country") : "") ||
      "",
  );

  const contactDetails: any = addCountryWiseContactInfo(country);
  const phoneContact = contactDetails.find((c: any) => c.link?.startsWith("tel:"));

  return { contactDetails, phoneContact, country };
};

export default useCountryContactInfo;
